import { api } from './client'
import type { Plan } from './platform'

/** This period's metered usage against the current plan's allowances. */
export interface BillingUsage {
  periodStart: string
  periodEnd: string
  seatsUsed: number
  seatLimit: number | null
  emailSent: number
  emailIncluded: number | null
  smsSent: number
  dedicatedNumbers: number
}

/** Stripe subscription-state mirror; null until the agency has a subscription. */
export interface Subscription {
  status: string // trialing | active | past_due | canceled | ...
  currentPeriodEnd: string | null
  trialEndsAt: string | null
}

export interface BillingSummary {
  plan: Plan | null
  subscription: Subscription | null
  usage: BillingUsage
  availablePlans: Plan[]
}

export async function getBilling(): Promise<BillingSummary> {
  const { data } = await api.get<BillingSummary>('/api/billing')
  return data
}

/** Start a hosted Stripe Checkout session; returns the URL to redirect the browser to. */
export async function startCheckout(planKey?: string): Promise<string> {
  const { data } = await api.post<{ url: string }>('/api/billing/checkout', { planKey })
  return data.url
}

/** Open a Stripe Billing Portal session (manage / cancel); returns the URL to redirect to. */
export async function openBillingPortal(): Promise<string> {
  const { data } = await api.post<{ url: string }>('/api/billing/portal', {})
  return data.url
}
